import styled, { css } from "styled-components";

const color = ({ $outline, theme }) => {
  if ($outline) return theme.colors.neutral.white;

  return theme.colors.neutral.white;
};

const backgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.primary.blue;
};

const hoverBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return theme.colors.neutral.white;

  return theme.colors.hues.blueShade1;
};

const hoverColor = ({ $outline, theme }) => {
  if ($outline) return theme.colors.neutral.black;

  return theme.colors.neutral.white;
};

const outline = ({ $outline, theme }) => {
  if ($outline) return `2px solid ${theme.colors.neutral.white} `;

  return "none";
};

const focusBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.feedbackState.hover;
};

const focusOutline = () => {
  // return `4px solid ${theme.colors.shade.vividTint2}`;
};

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10px;
`;

export const PrimaryButtonStructure = css`
  color: ${color};
  background-color: ${backgroundColor};
  border: ${outline};

  &:hover:not([disabled]) {
    color: ${hoverColor};
    background-color: ${hoverBackgroundColor};
  }

  &:focus {
    background-color: ${focusBackgroundColor};
    outline: ${focusOutline};
  }
`;
